import { Button, Divider, Grid, Skeleton, Typography } from "@mui/material"

export const AccountInfoSkeleton = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid display={"flex"} flexDirection={"column"}  marginTop={'28px'}>
            <Grid display={"flex"} flexDirection={"column"} > 
                <Grid display={"flex"} flexDirection={"row"}  marginBottom={1}>
                    <Grid flex={0.70}>
                        <Skeleton variant="rectangular" height={'21px'} width={'200px'}/>
                    </Grid>
                    <Grid flex={1}>
                        <Skeleton variant="rectangular" height={'21px'} width={'200px'}/>
                    </Grid>
                    <Grid></Grid>
                </Grid>
                <Divider />
            </Grid>
        </Grid>
    )
}